export default [{
    header: 'Usuarios',
    icon: 'UsersIcon',
    children: [
        {
            title: 'Lista',
            route: 'user-management-list',
            icon: 'ListIcon',
            action: 'manage',
            resource: 'user-management'
        },
        {
            title: 'Nuevo',
            route: 'user-management-create',
            icon: 'UserPlusIcon',
            action: 'manage',
            resource: 'user-management'
        },
        {
            title: 'Config. Aprobaciones',
            route: 'approval-config',
            icon: 'SettingsIcon',
            action: 'manage',
            resource: 'user-management'
        }
    ]
}];
